import React, { useEffect, useState } from 'react';
import { Card, Image } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { Container, Col, Row } from 'react-bootstrap';
import axios from 'axios';
import { serverurl } from '../../providers/ServerUrl';
import '../EventDetail.css';

export const News = () => {
  const [news, setNews] = useState([]);

  const fetchNewsData = () => {
    return axios.get(serverurl + "/api/news")
      .then((response) => setNews(response.data['news']))
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    fetchNewsData();
  }, []);

  return (
    <div className="news-page-wrap">
      {/* Banner */}
      <div>
        <div style={{ position: 'relative' }}>
          <Image fluid src="images/headerbanner.png" alt="Card image" id="bannerimg" />
          <div id="banneroverlay">
            <div id="bannerid" className='text-center'>
              <h4>NEWS</h4>
            </div>
          </div>
        </div>
      </div>

      <Container className="py-5">
        <Row className="g-4">
          {news && news.length > 0 ? (
            news.map((newsData, index) => {
              return (
                <React.Fragment key={newsData.news_id || index}>
                  {newsData.news_title !== '' ? (
                    <Col lg={4} md={6} sm={12}>
                      <div id="deptcard" className="news-modern-card h-100">
                        <div className="news-img-container">
                          <img
                            src={newsData.news_file}
                            alt={newsData.news_title}
                            onError={(e) => { e.target.src = "images/about.png"; }}
                          />
                          {newsData.news_date && (
                            <div className="news-date-badge">
                              {newsData.news_date}
                            </div>
                          )}
                        </div>
                        <div className="news-card-body d-flex flex-column flex-grow-1 p-3">
                          <h5 id="bluecolor" className="news-card-title mb-3">
                            {newsData.news_title}
                          </h5>
                          <div className="mt-auto">
                            <Link
                              to={"/news-details?newsid=" + newsData.news_id}
                              className="news-card-btn"
                              reloadDocument
                            >
                              New Details
                            </Link>
                          </div>
                        </div>
                      </div>
                    </Col>
                  ) : (
                    <Col md={12} key={index}>
                      <Card id="deptcard" className="p-4 text-center">
                        <Card.Body>
                          <Card.Title>No News For Now</Card.Title>
                        </Card.Body>
                      </Card>
                    </Col>
                  )}
                </React.Fragment>
              );
            })
          ) : (
            <Col md={12}>
              <Card id="deptcard" className="p-4 text-center">
                <Card.Body>
                  <Card.Title>No News For Now</Card.Title>
                </Card.Body>
              </Card>
            </Col>
          )}
        </Row>
      </Container>
    </div>
  );
};
